<div role="status">
  <app-icons icon="spinner-third" svgClass="{{sizeClasses()}} text-neutral-tertiary animate-spin fill-brand"></app-icons>
  <span class="sr-only">Loading...</span>
</div>
